const Id = localStorage.getItem("adminId");

export const API_ROOT = `${window.location.origin}/api`;
export const API = `${API_ROOT}/${Id}`;
